/**
 * =============================================================================
 * sticky-promo-banner.js
 * =============================================================================
 * Sticky promo banner display at the bottom of a page
 * =============================================================================
 */

 var StickyPromoBanner = {
  selectors: {
    banner: "#banner-sticky",
    close_button: "#banner-sticky button"
  },

  /**
   * Check if banner was closed already - if not, show the banner
   */
  init: function(){
    var notClosed = Cookies.get('banner-sticky-closed') === undefined;
    if(notClosed){
      let banner = document.querySelector(this.selectors.banner);
      if(!banner){
        return;
      }
      let closeButton = document.querySelector(this.selectors.close_button);
      banner.classList.remove("d-none");
      closeButton.addEventListener("click", this.handleAgreement.bind(this));
    }
  },

  /**
   * Hide the banner once agreed, and set a cookie to prevent showing in future
   */
  handleAgreement: function() {
    let banner = document.querySelector(this.selectors.banner);
    banner.classList.add('fade-out');
    banner.onanimationend = () => { banner.classList.add("d-none"); };
    Cookies.set('banner-sticky-closed', "true");
  }
};

export default StickyPromoBanner;